import React from "react"

import CTASectionDesktop from "./CTASectionDesktop"
import CTASectionMobile from "./CTASectionMobile"

const CTASection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return <CTASectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  }

  if (viewMode === "desktop") {
    return <CTASectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return <CTASectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  }

  // Default to desktop for desktop devices
  return <CTASectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
}

export default CTASection
